const Security = () => {
  return (
    <section id="seguranca" className="content-section">
      <div className="card mb-3">
        <div className="card-body text-center">
          <h5 className="card-title">Segurança</h5>
        </div>

        <div className="card-body">
          <div className="card">
            <div className="card-body">
              <ol className="list-styled mt-0 pt-0">


                <div>
                  <p className="mb-0">
                    <strong>Firewall</strong>
                  </p>
                  <p className="justified-text">
                    Restrição de acesso nas operações de transmissão ou recepção de dados.
                  </p>

                  <div className="d-flex justify-content-center">
                    <img src="./res/figures/firewall.png" className="card-img-bottom img-xl" alt="" />
                  </div>

                  <ul className="p-xss-0 p-md-3 justified-text pt-0 pb-0 mb-0">
                    <ul className="p-xss-0 p-md-3 justified-text pt-0 pb-0 mb-0">
                      <ul className="p-xss-0 p-md-3 justified-text pt-0 pb-0 mb-0">
                        <li>
                          <p className="mb-0 justified-text">
                            <strong>Habilitar firewall: </strong>habilita o firewall.
                          </p>
                        </li>
                        <li>
                          <p className="mb-0 justified-text">
                            <strong>Habilitar ping na WAN: </strong>desbloqueia o ping na WAN (disponível apenas quando em modo roteador).
                          </p>
                        </li>
                        <li>
                          <p className="mb-0 justified-text">
                            <strong>Habilitar UPnP: </strong>habilita o Universal Plug & Play (disponível apenas quando em modo roteador).
                          </p>
                        </li>
                        <li>
                          <div className="mb-0 justified-text">
                            <strong>Segurança: </strong>permite a ativação de defesas contra ataques e falhas conhecidas. (Ativadas por padrão)
                            <ul className="p-xss-0 p-md-3 justified-text pt-0">
                              <li>
                                <p className="mb-0 justified-text">
                                  <strong>Defesa contra ataque ICMP Flood:</strong> impede conexões ICMP de alto tráfego para o roteador ou através dele (aceita até 2/segundo com burst de 3).
                                </p>
                              </li>
                              <li>
                                <p className="mb-0 justified-text">
                                  <strong>Defesa contra ataque TCP SYN Flood:</strong> impede conexões TCP com flags FIN, SYN, RST, ACK/SYN de alto tráfego para o roteador ou através dele (aceita até 25/segundo com burst de 50).
                                </p>
                              </li>
                              <li>
                                <p className="mb-0 justified-text">
                                  <strong>Defesa contra ataque UDP Flood:</strong> impede conexões UDP de alto tráfego para o roteador ou através dele (aceita 10/segundo com burst de 20).
                                </p>
                              </li>
                              <li>
                                <p className="mb-0 justified-text">
                                  <strong>Defesa contra escaneamento de portas/Flags inválidas TCP:</strong> impede conexões TCP com flags FIN, SYN, RST, ACK/SYN de alto tráfego para o roteador ou através dele (aceita até 25/segundo com burst de 50).
                                </p>
                              </li>
                              <li>
                                <p className="mb-0 justified-text">
                                  <strong>Defesa contra IP Spoofing:</strong> impede conexões com IPs forjados/falsificados.
                                </p>
                              </li>
                              <li>
                                <p className="mb-0 justified-text">
                                  <strong>Defesa contra pacotes inválidos:</strong> impede transmissão de pacotes sem características válidas.
                                </p>
                              </li>
                            </ul>
                          </div>
                        </li>
                      </ul>
                    </ul>
                  </ul>
                </div>



                <div>
                  <p className="mb-0">
                    <strong id="dmz-portas">DMZ e Redirecionamento de Portas</strong>
                  </p>
                  <p className="mb-0 justified-text">
                    Permite definir uma DMZ e também adicionar e remover regras de redirecionamento de portas.
                  </p>
                  <p className="mb-0 justified-text">
                    <strong>Obs.: </strong>essa funcionalidade está disponível apenas quando o modo de operação for Roteador.
                  </p>

                  <ul className="p-xss-0 p-md-3 justified-text pt-0">
                    <ul className="p-xss-0 p-md-3 justified-text pt-0">
                      <ul className="p-xss-0 p-md-3 justified-text pt-0">
                        <li>
                          <p className="mb-0 justified-text">
                            <strong>Descrição: </strong>descrição do controle.
                          </p>
                        </li>
                        <li>
                          <p className="mb-0 justified-text">
                            <strong>IP: </strong>endereço IP destino.
                          </p>
                        </li>
                      </ul>
                    </ul>
                  </ul>

                  <p className="mb-0">
                    <strong>Redirecionamento de portas (simples)</strong>
                  </p>

                  <div className="d-flex justify-content-center">
                    <img src="./res/figures/redirecionamento-dmz-simples.png" className="card-img-bottom img-lg img-xl" alt="" />
                  </div>

                  <ul className="p-xss-0 p-md-3 justified-text pt-0">
                    <ul className="p-xss-0 p-md-3 justified-text pt-0">
                      <ul className="p-xss-0 p-md-3 justified-text pt-0">
                        <li>
                          <p className="mb-0 justified-text">
                            <strong>Descrição: </strong>descrição do controle.
                          </p>
                        </li>
                        <li>
                          <p className="mb-0 justified-text">
                            <strong>Intervalo de portas: </strong>intervalo de portas a ser redirecionado.
                          </p>
                        </li>
                        <li>
                          <p className="mb-0 justified-text">
                            <strong>Protocolo: </strong>selecione TCP, UDP ou TCP/UDP.
                          </p>
                        </li>
                        <li>
                          <p className="mb-0 justified-text">
                            <strong>IP de Destino: </strong>endereço IP de destino.
                          </p>
                        </li>
                      </ul>
                      <p className="justified-text">
                        Use o botão <i className="fa fa-plus-circle" aria-hidden="true"></i>
                        <strong>Adicionar</strong> para criar as regras, ou use o botão
                        <i className="fa fa-trash" aria-hidden="true"></i> para excluir uma regra.
                      </p>
                    </ul>
                  </ul>

                  <p className="mb-0">
                    <strong>Redirecionamento de portas (avançado)</strong>
                  </p>

                  <div className="d-flex justify-content-center img-container">
                    <img src="./res/figures/redirecionamento-dmz-avancado.png" className="card-img-bottom img-lg img-xl" alt="" />
                  </div>

                  <ul className="p-xss-0 p-md-3 justified-text pt-0">
                    <ul className="p-xss-0 p-md-3 justified-text pt-0">
                      <ul className="p-xss-0 p-md-3 justified-text pt-0">
                        <li>
                          <p className="mb-0 justified-text">
                            <strong>Descrição: </strong>descrição do controle.
                          </p>
                        </li>
                        <li>
                          <p className="mb-0 justified-text">
                            <strong>Porta Origem: </strong>define a porta que um dispositivo na internet vai acessar o IP público.
                          </p>
                        </li>
                        <li>
                          <p className="mb-0 justified-text">
                            <strong>IP destino: </strong>define o IP do equipamento interno que receberá a conexão.
                          </p>
                        </li>
                        <li>
                          <p className="mb-0 justified-text">
                            <strong>Porta destino: </strong>define a porta do equipamento interno que receberá a conexão.
                          </p>
                        </li>
                        <li>
                          <p className="mb-0 justified-text">
                            <strong>Protocolo: </strong>TCP, UDP, TCP e UDP.
                          </p>
                        </li>
                      </ul>
                      <p className="justified-text">
                        Use o botão <i className="fa fa-plus-circle" aria-hidden="true"></i>
                        <strong>Adicionar</strong> para criar as regras, ou use o botão
                        <i className="fa fa-trash" aria-hidden="true"></i> para excluir uma regra.
                      </p>
                    </ul>
                  </ul>
                </div>




                <div>
                  <p className="mb-0">
                    <strong id="regras-firewall">Regras de firewall</strong>
                  </p>
                  <p className="mb-0 justified-text">
                    Permite configurar regras de firewall avançadas, controlando tráfego com base em protocolo, endereço IP, rede e portas. Indicado para profissionais de rede experientes.
                  </p>
                  <p className="mb-0 justified-text">
                    <strong>Obs.: </strong>essa funcionalidade está disponível apenas quando o modo de operação for Roteador.
                  </p>

                  <p className="mb-0">
                    <strong>Controle por MAC</strong>
                  </p>
                  <p className="mb-0 justified-text">
                    Permite adicionar/remover regras de bloqueio ou liberação de acesso por endereço MAC.
                  </p>
                  <p className="mb-0 justified-text">
                    <strong>Obs.: </strong>essa funcionalidade está disponível apenas quando o modo de operação for Roteador.
                  </p>

                  <div className="d-flex justify-content-center">
                    <img src="./res/figures/controle-mac.png" className="card-img-bottom img-lg img-xl" alt="" />
                  </div>

                  <ul className="p-xss-0 p-md-3 justified-text pt-0">
                    <li>
                      <p className="mb-0 justified-text">
                        <strong>Descrição: </strong>descrição do controle.
                      </p>
                    </li>
                    <li>
                      <p className="mb-0 justified-text">
                        <strong>MAC: </strong>endereço MAC a ser bloqueado
                      </p>
                    </li>
                  </ul>
                  <p className="justified-text">
                    Use o botão <i className="fa fa-plus-circle" aria-hidden="true"></i>
                    <strong>Adicionar</strong> para criar as regras, ou use o botão
                    <i className="fa fa-trash" aria-hidden="true"></i> para excluir uma regra.
                  </p>
                  <p>
                    É possível habilitar ou desabilitar o bloqueio através da ação bloquear localizada na tabela onde são apresentadas as regras.
                  </p>

                  <p className="mb-0">
                    <strong>Controle por IP</strong>
                  </p>
                  <p className="mb-0 justified-text">
                    Permite adicionar/remover regras de bloqueio ou liberação de acesso por endereço IP.
                  </p>
                  <p className="mb-0 justified-text">
                    <strong>Obs.: </strong>essa funcionalidade está disponível apenas quando o modo de operação for Roteador.
                  </p>

                  <ul className="p-xss-0 p-md-3 justified-text pt-0">
                    <li>
                      <p className="mb-0 justified-text">
                        <strong>Tipo de Controle: </strong>escolha entre Controle por IP ou Controle por Faixa de Rede.
                      </p>
                    </li>
                  </ul>

                  <p className="mb-0">
                    <strong>Controle por IP</strong>
                  </p>

                  <div className="d-flex justify-content-center">
                    <img src="./res/figures/controle-rede-ip.png" className="card-img-bottom img-xl" alt="" />
                  </div>

                  <ul className="p-xss-0 p-md-3 justified-text pt-0">
                    <li>
                      <p className="mb-0 justified-text">
                        <strong>Liberar tráfego / Bloquear tráfego: </strong>define se a regra que será criada será para liberar ou bloquear o endereço IP informado.
                      </p>
                    </li>
                    <li>
                      <p className="mb-0 justified-text">
                        <strong>Descrição: </strong>descrição do controle.
                      </p>
                    </li>
                    <li>
                      <p className="mb-0 justified-text">
                        <strong>Protocolo: </strong>permite selecionar o tipo de protocolo que será realizado o controle da rede.
                      </p>
                    </li>
                    <li>
                      <p className="mb-0 justified-text">
                        <strong> IP/Rede: </strong>endereço IP ou faixa de rede a ser bloqueado ou liberado, bem como a máscara de sub-rede.
                      </p>
                    </li>
                  </ul>

                  <p className="justified-text">
                    Use o botão <i className="fa fa-plus-circle" aria-hidden="true"></i>
                    <strong>Adicionar</strong> para criar as regras, ou use o botão
                    <i className="fa fa-trash" aria-hidden="true"></i> para excluir uma regra.
                  </p>
                  <p className="justified-text">
                    Uma vez a regra criada é possível editar sua descrição, ação, protocolo e também o IP/Rede definidos.
                  </p>
                  <p className="justified-text">
                    É possível habilitar ou desabilitar as regras através da ação Habilitar localizada na tabela onde são apresentadas as regras.
                  </p>

                  <p className="mb-0">
                    <strong>Controle por faixa</strong>
                  </p>

                  <div className="d-flex justify-content-center">
                    <img src="./res/figures/controle-rede-ip-faixa.png" className="card-img-bottom img-xl" alt="" />
                  </div>

                  <ul className="p-xss-0 p-md-3 justified-text pt-0">
                    <li>
                      <p className="mb-0 justified-text">
                        <strong>Liberar tráfego / Bloquear tráfego: </strong>define se a regra que será criada será para liberar ou bloquear o endereço IP informado.
                      </p>
                    </li>
                    <li>
                      <p className="mb-0 justified-text">
                        <strong>Descrição: </strong>descrição do controle.
                      </p>
                    </li>
                    <li>
                      <p className="mb-0 justified-text">
                        <strong>Protocolo: </strong>permite selecionar o tipo de protocolo que será realizado o controle da rede.
                      </p>
                    </li>
                    <li>
                      <p className="mb-0 justified-text">
                        <strong>IP inicial: </strong>endereço IP que inicia a faixa de IP a ser liberada ou bloqueada.
                      </p>
                    </li>
                    <li>
                      <p className="mb-0 justified-text">
                        <strong>IP Final: </strong>endereço IP que finaliza a faixa de IP a ser liberada ou bloqueada.
                      </p>
                    </li>
                  </ul>

                  <p className="justified-text">
                    Use o botão <i className="fa fa-plus-circle" aria-hidden="true"></i>
                    <strong>Adicionar</strong> para criar as regras, ou use o botão
                    <i className="fa fa-trash" aria-hidden="true"></i> para excluir uma regra.
                  </p>
                  <p className="justified-text">
                    Uma vez a regra criada é possível editar sua descrição, ação, protocolo e também o IP/Rede definidos.
                  </p>
                  <p className="justified-text">
                    É possível habilitar ou desabilitar as regras através da ação Habilitar localizada na tabela onde são apresentadas as regras.
                  </p>

                  <p className="mb-0">
                    <strong>Modo avançado</strong>
                  </p>
                  <p style={{ color: '#EAB42A' }}>
                    Estas configurações exigem um grau avançado de conhecimento sobre redes. Apenas altere as opções de tráfego se tiver consciência dos efeitos em sua rede.
                  </p>

                  <div className="d-flex justify-content-center">
                    <img src="./res/figures/controle-rede-ip-avancado.png" className="card-img-bottom img-xl" alt="" />
                  </div>

                  <ul className="p-xss-0 p-md-3 justified-text pt-0">
                    <li>
                      <p className="mb-0 justified-text">
                        <strong>Liberar tráfego / Bloquear tráfego: </strong>define se a regra que será criada será para liberar ou bloquear o endereço IP informado.
                      </p>
                    </li>
                    <li>
                      <p className="mb-0 justified-text">
                        <strong>Descrição: </strong>descrição do controle.
                      </p>
                    </li>
                    <li>
                      <p className="mb-0 justified-text">
                        <strong>Protocolo: </strong>permite selecionar o tipo de protocolo que será realizado o controle da rede.
                      </p>
                    </li>
                    <li>
                      <p className="mb-0 justified-text">
                        <strong>IP/Rede e porta de origem: </strong>endereço IP/Rede e/ou Porta a rede a ser liberado ou bloqueado. Podendo ser definido uma exceção para a regra. Ou seja, aplicar a todos menos o IP/rede e/ou porta definida.
                      </p>
                    </li>
                    <li>
                      <p className="mb-0 justified-text">
                        <strong>IP/Rede e porta de destino: </strong>endereço IP/Rede e/ou Porta a rede a ser liberado ou bloqueado. Podendo ser definido uma exceção para a regra. Ou seja, aplicar a todos menos o IP/rede e/ou porta definida.
                      </p>
                    </li>
                  </ul>

                  <p className="justified-text">
                    Use o botão <i className="fa fa-plus-circle" aria-hidden="true"></i>
                    <strong>Adicionar</strong> para criar as regras, ou use o botão
                    <i className="fa fa-trash" aria-hidden="true"></i> para excluir uma regra.
                  </p>
                  <p className="justified-text">
                    Uma vez a regra criada é possível editar sua descrição, ação, protocolo e também o IP/rede e/ou porta de origem e de destino definidos.
                  </p>
                  <p className="justified-text">
                    É possível habilitar ou desabilitar as regras através da ação Habilitar localizada na tabela onde são apresentadas as regras.
                  </p>
                </div>

              </ol>


            </div>
          </div>
        </div>
      </div>
    </section >
  );
};

export default Security;
